import { render, staticRenderFns } from "./RadioForm.vue?vue&type=template&id=bc4adf7c"
import script from "./RadioForm.vue?vue&type=script&lang=js"
export * from "./RadioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports